export const MAIN_ID = "main";
export const FOOTER_ID = "footer";
